import { Route } from 'react-router-dom'
import HomePage from './pages/HomePage'

const routes = [
	<Route path={'/'} element={<HomePage />} key='homePage' />,
	<Route path={'/:raffle'} element={<HomePage />} key='homePageRaffle' />
]

export default routes
